import { useState } from 'react';
import { accessJsonAttr, cleanUpSpecialChars } from '../../utils/utils';
import MgpIcon from '../MgpIcon/MgpIcon';
import { MgpInputProps } from './MgpInput.types';


export default function MgpFormInput({id, label, labelFontWeight, icon, iconPosition, iconColor, register, errors, ...props }: MgpInputProps)  {

    const [value, setValue] = useState('');
    const [inputType, setInputType] = useState(props.type);
    
    let labelClassName = "text fw-" + (labelFontWeight ? labelFontWeight: "medium");
    
    let inputClassName = "form-control";
    let fieldError;
    if(errors) {
        fieldError = accessJsonAttr(errors, id);
        if(fieldError) {
            inputClassName += " form-error";
            labelClassName += " form-error";
        }
    }

    const iconClick = (e: any) => {
        console.log("icon click", inputType);
        if(inputType === 'password') {
            setInputType('text');
        } else if(inputType === 'text' && props.type === 'password') {
            setInputType('password');
        }
    }


    const onChangeEvent = (e: any) => {
        if(props.autoCapitalize ==='characters') {
            setValue(cleanUpSpecialChars(e.currentTarget.value).toUpperCase());
        } else {
            setValue(e.currentTarget.value);
        }
        
        if(props.onChange) {
            props.onChange(e);
        }
    }


    if(icon) {
        if(!iconPosition) {
            iconPosition = "left";
        }
        let divClassName = "input-withicon-" + iconPosition;
        if(props.type === 'date' || props.type === "datetime-local") {
            divClassName = "input-date";
            iconPosition = "right";
        }
        
        
        return (
           <>
                {label&&<label className={labelClassName} htmlFor={id}>{label}</label>}
                <div className={divClassName}>
                    {iconPosition == 'left'&&<MgpIcon icon={icon} color={iconColor} onClick={iconClick}/>}
                    {register&&<input  {...props} type={inputType} className={inputClassName} id={id} {...register(id, {onChange:(e) => {onChangeEvent(e)}})}  value={value}  />}
                    {!register&&<input  {...props} type={inputType} className={inputClassName} id={id} value={value} onChange={onChangeEvent} />}
                    {iconPosition == 'right'&&<MgpIcon icon={icon} color={iconColor} onClick={iconClick}/>}
                </div>
                {fieldError && (<p className="error">{fieldError.message}</p>)}
               
            </>
        );
    } else {
        return (
            <>
                {label&&<label className={labelClassName} htmlFor={id}>{label}</label>}
                {register&&<input  type={inputType} className={inputClassName} id={id} {...register(id, {onChange: (e) => {onChangeEvent(e)}})}  value={value} {...props} />}
                {!register&&<input  type={inputType} className={inputClassName} id={id} value={value} onChange={onChangeEvent}  {...props} />}
                {fieldError && (<p className="error">{fieldError.message}</p>)}
            </>
        );
      };
    }